// src/data/servicesData.js
import serviceImage1 from '../assets/imgs/service1.png';
import serviceImage2 from '../assets/imgs/service2.png';
import serviceImage3 from '../assets/imgs/service3.png';
import serviceImage4 from '../assets/imgs/service4.png';
import serviceImage5 from '../assets/imgs/service5.png';
import serviceImage6 from '../assets/imgs/service6.png';

import clientImage1 from '../assets/imgs/client-1-img.png';
import clientImage2 from '../assets/imgs/client-2-img.png';
import clientImage3 from '../assets/imgs/client-3-img.png';

const servicesData = [
    {
        id: 1,
        title: "We will provide Logo Designing Services fo Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Ah, You must be here searching for a logo for your business? YOU ARE THE PERFECT PLACE!",
        description2: "Your logo will be designed by a team of creative and highly talented graphic artists using the modern and trendy techniques. We have more than 5 years of experience in Graphic Designing and our forte is Logo Designing.",
        features: ["Highly Conceptual and modern designs so that your logo can convey the brand's message to your audience.","We believe in color physiology because it brings the life to your brand's image.", "Unlimited revisions until we get the best logo design for your business.", "Complete source files in every package so that you can use it for printing purpose or can make any amendments easily"],
        pkjToChoose1: "Our STANDARD Best Seller $35 pack will be a good pack to start, But we do recommend you to get the $70 PREMIUM PACK because you'll get very best of:\n",
        pkjToChoose2: "PREMIUM initial logo concepts\n" +
            "Unlimited logo revisions\n" +
            "Complete branding: social media kit, Stationery & 3Dmockup",
        howItWorks: ["Share your business name, industry, and any design preferences (colors, style, inspiration).","Receive initial logo concepts", "Provide feedback, and I'll refine the design until it perfectly represents your brand."],
        finalpara: "Let's create a logo that truly represents your business! If you have any questions or need more information, feel free to contact me.",
        thankyou: "Thank you!",
        tags: ["Wordmark","Lettermark","Emblem", "Abstract","Pictorial", "Mascot" ,"Combination Mark", "Monogram","Badge", "Symbol", "Minimalist","Vintage","Modernl Retro","Geometric", "Hand-drawn", "Flat", "3D","Grunge", "Luxurious", "Design", "Branding"," Creative","Graphic Design"," High-Quality"],

        packages: [
            {
                name: "Basic",
                price: "$100",
                description: "Basic web design with up to 3 pages.",
                features: ["Responsive Design", "SEO Basics", "Contact Form"]
            },
            {
                name: "Standard",
                price: "$100",
                description: "Basic web design with up to 3 pages.",
                features: ["Responsive Design", "SEO Basics", "Contact Form"]
            },
            {
                name: "Premium",
                price: "$100",
                description: "Basic web design with up to 3 pages.",
                features: ["Responsive Design", "SEO Basics", "Contact Form"]
            },
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],

    },
    {
        id: 2,
        title: "We will do Comprehensive Brand Style Guide Design for Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Welcome to our Comprehensive Brand Style Guide Design Service!",
        description2: "In today’s competitive market, maintaining a consistent and professional brand image is crucial for success. Our service is designed to help businesses establish a cohesive and visually appealing brand identity that can be applied across all marketing channels. Whether you are a new business looking to define your brand or an established company seeking to solidify your branding efforts, we are here to create a detailed and effective brand style guide for you.",
        features: [
            "Highly conceptual and modern designs to effectively convey your brand's message to your audience.",
            "Expertise in color psychology to bring life to your brand's image.",
            "Unlimited revisions until we achieve the perfect brand identity for your business.",
            "Complete source files in every package for easy future use and amendments."
        ],
        pkjToChoose1: "Our STANDARD Best Seller $50 pack is a great place to start, but we highly recommend the $100 PREMIUM PACK because you'll receive the best of:",
        pkjToChoose2: "PREMIUM brand identity concepts\n" +
            "Unlimited revisions\n" +
            "Complete branding package: social media kit, stationery design, and 3D mockups",
        howItWorks: [
            "Share your business name, industry, and any design preferences (colors, style, inspiration).",
            "Receive initial brand identity concepts.",
            "Provide feedback, and we'll refine the design until it perfectly represents your brand."
        ],
        finalpara: "Let's create a brand identity that truly represents your business! If you have any questions or need more information, feel free to contact us.",
        thankyou: "Thank you!",
        tags: [
            "Branding", "Identity", "Graphic Design", "Logo", "Modern", "Creative", "High-Quality",
            "Visual Identity", "Brand Strategy", "Corporate Identity", "Business Identity",
            "Design", "Brand Development", "Professional"
        ],
        packages: [
            {
                name: "Basic",
                price: "$50",
                description: "Basic brand identity package with logo design.",
                features: ["Logo Design", "Color Palette", "Basic Branding Guidelines"]
            },
            {
                name: "Standard",
                price: "$75",
                description: "Standard brand identity package with extended features.",
                features: ["Logo Design", "Color Palette", "Typography", "Branding Guidelines", "Business Card Design"]
            },
            {
                name: "Premium",
                price: "$100",
                description: "Premium brand identity package with comprehensive features.",
                features: ["Logo Design", "Color Palette", "Typography", "Branding Guidelines", "Business Card Design", "Social Media Kit", "Stationery Design", "3D Mockups"]
            }
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],
    }
    ,
    {
        id: 3,
        title: "We will provide Stationery Designing Services for Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Ah, You must be here searching for professional stationery designs for your business? YOU ARE AT THE PERFECT PLACE!",
        description2: "Your stationery will be designed by a team of creative and highly talented graphic artists using modern and trendy techniques. We have more than 5 years of experience in Graphic Designing and our forte is creating cohesive and attractive stationery that enhances your brand's image.",
        features: [
            "Highly conceptual and modern designs to ensure your stationery reflects your brand's identity.",
            "Attention to detail to bring sophistication and professionalism to your business materials.",
            "Unlimited revisions until we get the perfect stationery design for your business.",
            "Complete source files in every package for easy future use and amendments."
        ],
        pkjToChoose1: "Our STANDARD Best Seller $40 pack is a great place to start, but we highly recommend the $80 PREMIUM PACK because you'll receive the best of:",
        pkjToChoose2: "PREMIUM stationery design concepts\n" +
            "Unlimited revisions\n" +
            "Complete stationery set: business cards, letterheads, envelopes, and more",
        howItWorks: [
            "Share your business name, industry, and any design preferences (colors, style, inspiration).",
            "Receive initial stationery design concepts.",
            "Provide feedback, and we'll refine the design until it perfectly represents your brand."
        ],
        finalpara: "Let's create stationery that truly represents your business! If you have any questions or need more information, feel free to contact us.",
        thankyou: "Thank you!",
        tags: [
            "Stationery", "Design", "Branding", "Graphic Design", "Business Cards", "Letterheads",
            "Envelopes", "Professional", "Creative", "High-Quality", "Office Supplies", "Custom Design",
            "Corporate Identity", "Modern", "Elegant", "Unique"
        ],
        packages: [
            {
                name: "Basic",
                price: "$40",
                description: "Basic stationery design package with essential items.",
                features: ["Business Card Design", "Letterhead Design", "Envelope Design"]
            },
            {
                name: "Standard",
                price: "$60",
                description: "Standard stationery design package with extended features.",
                features: ["Business Card Design", "Letterhead Design", "Envelope Design", "Compliment Slip Design", "Notepad Design"]
            },
            {
                name: "Premium",
                price: "$80",
                description: "Premium stationery design package with comprehensive features.",
                features: ["Business Card Design", "Letterhead Design", "Envelope Design", "Compliment Slip Design", "Notepad Design", "Presentation Folder Design", "Custom Stationery Item"]
            }
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],
    }
    ,
    {
        id: 4,
        title: "Professional Social Media Kit Design Services for Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Looking to elevate your social media presence with stunning, cohesive designs? YOU ARE AT THE RIGHT PLACE!",
        description2: "Our team of creative and highly skilled graphic artists will craft a social media kit that perfectly represents your brand using the latest design trends. With over 5 years of experience in Graphic Design, we specialize in creating captivating social media kits that enhance your online identity.",
        features: [
            "Modern and conceptual designs to ensure your social media profiles reflect your brand's essence.",
            "Expert attention to detail, adding sophistication and professionalism to your social media materials.",
            "Unlimited revisions to achieve the perfect social media kit for your business.",
            "Complete source files provided with every package for easy future use and adjustments."
        ],
        pkjToChoose1: "Our STANDARD Best Seller $45 package is a fantastic starting point, but we highly recommend the $90 PREMIUM PACKAGE for the ultimate experience, including:",
        pkjToChoose2: "PREMIUM social media kit design concepts\n" +
            "Unlimited revisions\n" +
            "Complete social media suite: profile pictures, cover photos, post templates, and more",
        howItWorks: [
            "Share your business name, industry, and any design preferences (colors, style, inspiration).",
            "Receive initial social media kit design concepts.",
            "Provide feedback, and we'll refine the designs until they perfectly represent your brand."
        ],
        finalpara: "Let's create a social media kit that truly represents your business! If you have any questions or need further information, feel free to contact us.",
        thankyou: "Thank you!",
        tags: [
            "Social Media", "Kit", "Design", "Branding", "Graphic Design", "Profile Pictures",
            "Cover Photos", "Post Templates", "Professional", "Creative", "High-Quality",
            "Online Presence", "Custom Design", "Corporate Identity", "Modern", "Elegant", "Unique"
        ],
        packages: [
            {
                name: "Basic",
                price: "$45",
                description: "Essential social media kit with key components.",
                features: ["Profile Picture Design", "Cover Photo Design", "Post Template Design"]
            },
            {
                name: "Standard",
                price: "$70",
                description: "Enhanced social media kit with additional elements.",
                features: ["Profile Picture Design", "Cover Photo Design", "Post Template Design", "Story Template Design", "Highlight Covers"]
            },
            {
                name: "Premium",
                price: "$90",
                description: "Comprehensive social media kit with all-inclusive features.",
                features: ["Profile Picture Design", "Cover Photo Design", "Post Template Design", "Story Template Design", "Highlight Covers", "Banner Design", "Ad Template Design"]
            }
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],
    }
    ,
    {
        id: 5,
        title: "Expert Packaging and Packing Design Services for Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Seeking professional packaging and packing designs to make your products stand out? YOU ARE AT THE RIGHT PLACE!",
        description2: "Our team of creative and experienced graphic designers will develop packaging and packing designs that not only protect your products but also enhance their appeal using cutting-edge techniques. With over 5 years of experience in Packaging Design, we excel in creating designs that capture attention and convey your brand's essence.",
        features: [
            "Innovative and modern designs that ensure your packaging communicates your brand's message effectively.",
            "Meticulous attention to detail to elevate the aesthetic and functional aspects of your packaging.",
            "Unlimited revisions to achieve the perfect packaging design for your business.",
            "Complete source files included in every package for easy future use and modifications."
        ],
        pkjToChoose1: "Our STANDARD Best Seller $60 package is an excellent choice to begin with, but we highly recommend the $120 PREMIUM PACKAGE for the best experience, including:",
        pkjToChoose2: "PREMIUM packaging design concepts\n" +
            "Unlimited revisions\n" +
            "Complete packaging suite: box designs, labels, inserts, and more",
        howItWorks: [
            "Share your product details, brand guidelines, and any design preferences (colors, style, inspiration).",
            "Receive initial packaging design concepts.",
            "Provide feedback, and we'll refine the designs until they perfectly represent your brand and product."
        ],
        finalpara: "Let's create packaging that truly represents your business and products! If you have any questions or need further information, feel free to contact us.",
        thankyou: "Thank you!",
        tags: [
            "Packaging", "Packing", "Design", "Branding", "Graphic Design", "Box Designs",
            "Labels", "Inserts", "Professional", "Creative", "High-Quality",
            "Product Packaging", "Custom Design", "Corporate Identity", "Modern", "Elegant", "Unique"
        ],
        packages: [
            {
                name: "Basic",
                price: "$60",
                description: "Essential packaging design package with key components.",
                features: ["Box Design", "Label Design", "Basic Insert Design"]
            },
            {
                name: "Standard",
                price: "$90",
                description: "Enhanced packaging design package with additional elements.",
                features: ["Box Design", "Label Design", "Insert Design", "Packaging Mockups", "Product Photography"]
            },
            {
                name: "Premium",
                price: "$120",
                description: "Comprehensive packaging design package with all-inclusive features.",
                features: ["Box Design", "Label Design", "Insert Design", "Packaging Mockups", "Product Photography", "Custom Packaging Materials", "3D Renderings"]
            }
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],
    }
    ,
    {
        id: 6,
        title: "Professional Web UI/UX Design Services for Your Business",
        images: [serviceImage1, serviceImage2, serviceImage3],
        description1: "Looking to elevate your website with exceptional UI/UX design? YOU ARE AT THE RIGHT PLACE!",
        description2: "Our team of creative and highly skilled designers will craft an intuitive and visually stunning UI/UX design for your website using the latest industry techniques. With over 5 years of experience in Web Design, we specialize in creating user-friendly and aesthetically pleasing websites that engage and convert.",
        features: [
            "Innovative and user-centric designs that enhance user experience and engagement.",
            "Meticulous attention to detail to ensure a seamless and enjoyable user journey.",
            "Unlimited revisions to achieve the perfect UI/UX design for your website.",
            "Complete source files included in every package for easy future updates and modifications."
        ],
        pkjToChoose1: "Our STANDARD Best Seller $150 package is an excellent starting point, but we highly recommend the $300 PREMIUM PACKAGE for the ultimate experience, including:",
        pkjToChoose2: "PREMIUM UI/UX design concepts\n" +
            "Unlimited revisions\n" +
            "Complete web design suite: responsive designs, interactive prototypes, and more",
        howItWorks: [
            "Share your website goals, target audience, and any design preferences (colors, style, inspiration).",
            "Receive initial UI/UX design concepts.",
            "Provide feedback, and we'll refine the designs until they perfectly represent your brand and meet user needs."
        ],
        finalpara: "Let's create a website that not only looks great but also provides an exceptional user experience! If you have any questions or need further information, feel free to contact us.",
        thankyou: "Thank you!",
        tags: [
            "Web Design", "UI/UX", "User Interface", "User Experience", "Branding", "Graphic Design",
            "Responsive Design", "Interactive", "Professional", "Creative", "High-Quality",
            "Custom Design", "Corporate Identity", "Modern", "Elegant", "Unique"
        ],
        packages: [
            {
                name: "Basic",
                price: "$150",
                description: "Essential web UI/UX design package with key components.",
                features: ["Home Page Design", "Basic UI Elements", "Wireframes"]
            },
            {
                name: "Standard",
                price: "$200",
                description: "Enhanced web UI/UX design package with additional features.",
                features: ["Home Page Design", "UI Elements", "Wireframes", "Interactive Prototypes", "Mobile Responsiveness"]
            },
            {
                name: "Premium",
                price: "$300",
                description: "Comprehensive web UI/UX design package with all-inclusive features.",
                features: ["Complete Web Design", "Advanced UI Elements", "Wireframes", "Interactive Prototypes", "Mobile Responsiveness", "User Testing", "Design System Documentation"]
            }
        ],
        reviews: [
            {
                clientName: "Alice Johnson",
                clientImage: clientImage1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: clientImage2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
        ],
    }
    ,

];

export default servicesData;
